/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2 } from '@coursera/cds-core';
import { CertificateIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/xdp';

const styles = {
  item: css`
    display: flex;
    gap: var(--cds-spacing-200);
  `,
  iconContainer: css`
    border-radius: 8px;
    background: #f4f7fa;
    display: flex;
    width: 76px;
    height: 54px;
    padding: calc(var(--cds-spacing-100) / 2);
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
  `,
  description: css`
    max-width: 608px;
    padding-top: var(--cds-spacing-100);
  `,
};

const CareerCertificateItem = () => {
  return (
    <div css={styles.item}>
      <div css={styles.iconContainer}>
        <CertificateIcon size="large" color="interactive" width={34} height={34} />
      </div>
      <div>
        <Typography2 component="h3" variant="subtitleLarge">
          {_t('Earn a career certificate')}
        </Typography2>
        <Typography2 component="p" variant="bodySecondary" css={styles.description}>
          {_t(
            'Add this credential to your LinkedIn profile, resume, or CV. Share it on social media and in your performance review.'
          )}
        </Typography2>
      </div>
    </div>
  );
};

export default CareerCertificateItem;
